import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import OpinionCard from "./OpinionCard";

import SofiaIMG from "../../assets/app/OpinionSection/SofiaR.png";
import CarlosIMG from "../../assets/app/OpinionSection/CarlosT.png";
import LauraIMG from "../../assets/app/OpinionSection/LauraP.png";
import MarioIMG from "../../assets/app/OpinionSection/MarioG.png";
import SergioIMG from "../../assets/app/OpinionSection/SergioP.png";

import "../../styles/app/OpinionSection.css";
import { useTranslation } from "react-i18next"; // Import useTranslation

const OpinionSection: React.FC = () => {
  const { t } = useTranslation(); // Initialize useTranslation

  const opinions = [
    {
      imageSrc: SofiaIMG,
      name: t("opinionSection.opinion1_name"),
      title: t("opinionSection.opinion1_title"),
      text: t("opinionSection.opinion1_text"),
      stars: 5,
    },
    {
      imageSrc: CarlosIMG,
      name: t("opinionSection.opinion2_name"),
      title: t("opinionSection.opinion2_title"),
      text: t("opinionSection.opinion2_text"),
      stars: 5,
    },
    {
      imageSrc: LauraIMG,
      name: t("opinionSection.opinion3_name"),
      title: t("opinionSection.opinion3_title"),
      text: t("opinionSection.opinion3_text"),
      stars: 5,
    },
    {
      imageSrc: MarioIMG,
      name: t("opinionSection.opinion4_name"),
      title: t("opinionSection.opinion4_title"),
      text: t("opinionSection.opinion4_text"),
      stars: 5,
    },
    {
      imageSrc: SergioIMG,
      name: t("opinionSection.opinion5_name"),
      title: t("opinionSection.opinion5_title"),
      text: t("opinionSection.opinion5_text"),
      stars: 5,
    },
  ];

  return (
    <section className="opinion-section">
      <p className="opinion-title">{t("opinionSection.title")}</p> {/* Translated title */}

      <Swiper
        modules={[Pagination, Navigation]}
        spaceBetween={30}
        slidesPerView={4} // Muestra 4 slides al mismo tiempo
        loop={true} // Habilita el bucle infinito
        pagination={{
          clickable: true, // Hace clickeables los puntos
        }}
        navigation={{
          nextEl: ".swiper-button-next", // Botón siguiente
          prevEl: ".swiper-button-prev", // Botón anterior
        }}
        breakpoints={{
          100: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        }}
      >
        {/* Slides */}
        {opinions.map((opinion, index) => (
          <SwiperSlide key={index}>
            <OpinionCard {...opinion} />
          </SwiperSlide>
        ))}

        {/* Flechas de navegación */}
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </Swiper>
    </section>
  );
};

export default OpinionSection;
